// Sample records for the local preview (Gary, 18 Oct: "mock up something locally first"). Never used on live chats.
import type { RecBooking, RecCustomer, RecService, RecordsApi } from '@/lib/records';

const CUSTOMER: RecCustomer = {
  id: 'sample-customer', type: 'individual', firstName: 'Sarah', lastName: 'Moodley', company: '',
  mobile: '082 123 4567', phone: '', email: 'sarah.moodley@example.com',
  street: '12 Vineyard Road', suburb: 'Durbanville', city: 'Cape Town', postcode: '7550',
  notes: 'Two dogs, gate code at the side entrance. Prefers afternoons.', tier: 'Gold', since: '2024-03-02', total: 7, last12: 3,
  territoryId: 'sample-area', billing: {},
};

const BOOKING: RecBooking = {
  id: 'sample-booking', code: 'BZA-NFXF8R', date: '2026-10-22', time: '15:30', end: '16:30', beds: 2, status: 'confirmed',
  street: '12 Vineyard Road', suburb: 'Durbanville', city: 'Cape Town', note: 'Gate code at the side entrance',
  territoryId: 'sample-area', area: 'Durbanville', operators: [{ id: 'op-barry', name: "Barry O'Donoghue" }],
};

const SERVICES: RecService[] = [
  { key: 's1', date: '2026-08-14', items: '2 beds', amount: 1450, operator: "Barry O'Donoghue", invoice: 'INV-ZA-025247', paid: false, payUrl: 'https://pay.example/INV-ZA-025247' },
  { key: 's2', date: '2026-04-02', items: '2 beds', amount: 1100, operator: "Barry O'Donoghue", invoice: 'INV-ZA-024310', paid: true, payUrl: null },
  { key: 's3', date: '2025-12-03', items: '2 beds, 1 × 3 Seater couch', amount: 1950, operator: "Barry O'Donoghue", invoice: 'INV-ZA-022876', paid: true, payUrl: null },
  { key: 's4', date: '2025-06-20', items: '1 bed', amount: 800, operator: 'Sue Gray', invoice: 'INV-ZA-020114', paid: true, payUrl: null },
];

const TIMES: Record<number, string[]> = { 1: ['08:00', '11:30', '14:00'], 3: ['09:00', '13:00'], 4: ['08:00', '10:30', '15:00'], 5: ['12:00'] };
const wait = () => new Promise((r) => setTimeout(r, 250));

/** The paid example has a booking ahead; the others show New booking. */
export function sampleRecords(chatId: string): RecordsApi {
  return {
    customer: async () => CUSTOMER,
    saveCustomer: async () => { await wait(); },
    nextBooking: async () => (chatId === 'ex-paid' ? BOOKING : null),
    areas: async () => [{ id: 'sample-area', name: 'Durbanville', shortCode: 'DBV' }, { id: 'sample-area-2', name: 'Bellville', shortCode: 'BLV' }],
    slots: async (_t, date) => { await wait(); return TIMES[new Date(`${date}T00:00:00Z`).getUTCDay()] ?? []; },
    operators: async () => [
      { id: 'op-barry', name: "Barry O'Donoghue", available: true },
      { id: 'op-sue', name: 'Sue Gray', available: true },
      { id: 'op-pieter', name: 'Pieter', available: false, reason: 'Already booked then' },
    ],
    create: async () => { await wait(); return 'BZA-NEW123'; },
    update: async () => { await wait(); },
    cancel: async () => { await wait(); },
    assign: async () => { await wait(); },
    history: async () => SERVICES,
  };
}
